import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Card, Subscription } from '../../shared/models/plans';
import { AccountSettingsService } from '../account-settings.service';

@Component({
  selector: 'cc-choose-account-blocked',
  templateUrl: './choose-account-blocked.component.html',
  styleUrls: ['./choose-account-blocked.component.scss']
})
export class ChooseAccountBlockedComponent implements OnInit {
  // public subscription$: Observable<Subscription>;
  public card$: Observable<Card>;

  constructor(private accountSettingsService: AccountSettingsService) {}

  ngOnInit() {
    // this.subscription$ = this.accountSettingsService.getSubscription();
    this.card$ = this.accountSettingsService.getCard();
  }
}
